import axios from 'axios';
import { logout } from '../helper/comman';
import { store } from '../redux/store';
import { BASE_API_URL } from 'helper/constant';

axios.interceptors.request.use(async (config) => {
  try {
    const {
      authReducer: { token },
    } = store.getState();
    if (token) {
      config.headers = {
        Authorization: `${token}`,
      };
    }

    return config;
  } catch (err) {
    Promise.reject(err);
  }
});

axios.interceptors.response.use(
  (res) => {
    return res;
  },
  (e) => {
    if (
      e.response?.status === 401 ||
      (e.response?.status === 403 &&
        !e.response?.request?.responseURL?.includes('/avatar'))
    ) {
      logout();

      return e.response;
    } else {
      return e.response;
    }
  }
);

export default axios;

const resolveBaseUrl = () => {
  const {
    authReducer: { location },
  } = store.getState();
  const savedDomain = typeof window !== 'undefined' ? window.localStorage?.getItem('SWITCH_SERVER_DOMAIN') : null;
  const base = location || savedDomain || BASE_API_URL || '';
  return base.replace(/\/+$/, '');
};

const resolveUrl = (url) => {
  const base = resolveBaseUrl();
  const cleanUrl = (url || '').replace(/^\/+/, '');
  return `${base}/${cleanUrl}`;
};

export const axiosPost = (url, data) => {
  return axios.post(resolveUrl(url), data);
};

export const axiosGet = (url, data) => {
  return axios.get(resolveUrl(url), {
    params: data,
  });
};

export const axiosDelete = (url) => {
  return axios.delete(resolveUrl(url));
};

export const axiosPatch = (url, data) => {
  return axios.patch(resolveUrl(url), data);
};

export const fetchImage = (url, header) => {
  return axios.get(resolveUrl(url), header);
};
